const FUNCTIONS_BASE_URL =
  process.env.REACT_APP_FUNCTIONS_BASE_URL ||
  'https://us-central1-prventanas.cloudfunctions.net';

const FUNCTION_OVERRIDES = {
  '/registerLandingLead': 'https://registerlandinglead-tx5s2j3yfq-uc.a.run.app',
  '/sendBusinessInfo': 'https://sendbusinessinfo-tx5s2j3yfq-uc.a.run.app',
  '/createCalendarEvent': 'https://createcalendarevent-tx5s2j3yfq-uc.a.run.app',
  '/sendClientEmail': 'https://sendclientemail-xjpm53xzha-uc.a.run.app/sendClientEmail',
  '/sendSmsNotification': 'https://sendsmsnotification-tx5s2j3yfq-uc.a.run.app',
  '/sendProjectProposal': 'https://sendprojectproposal-tx5s2j3yfq-uc.a.run.app',
  '/inviteSalesAgent': 'https://invitesalesagent-tx5s2j3yfq-uc.a.run.app',
  '/inviteTeamMember': 'https://us-central1-prventanas.cloudfunctions.net/inviteTeamMember',
  '/ecommerceCreatePaymentIntent': 'https://ecommercecreatepaymentintent-tx5s2j3yfq-uc.a.run.app',
  '/ecommerceFinalizeOrder': 'https://ecommercefinalizeorder-tx5s2j3yfq-uc.a.run.app',
};

const normalizePath = (path = '') => {
  if (!path) return '';
  return path.startsWith('/') ? path : `/${path}`;
};

export const buildFunctionUrl = (path = '') => {
  const normalized = normalizePath(path);
  const override = FUNCTION_OVERRIDES[normalized];
  if (override) return override;
  if (!normalized) return FUNCTIONS_BASE_URL;
  return `${FUNCTIONS_BASE_URL}${normalized}`;
};

export { FUNCTIONS_BASE_URL, FUNCTION_OVERRIDES };
